module.exports = __webpack_public_path__ + "static/media/Single.c19d5b20.svg";